// extracted by mini-css-extract-plugin
module.exports = {"appOuter":"_2qYus","leftPanel":"_30WXU","appDetail":"_32q0q","detailWrap":"cSfyw","iconWrap":"_3z_5y","invalid":"_2Lb3u","successful":"_1JdRO"};